module.exports = __webpack_public_path__ + "static/media/llanta-inspeccion-red.c76d1f2b.svg";